export default __webpack_public_path__ + "static/brand-11-eaddf15a691e2677fdfa9e2a03e5c56d.png";